/* ═══════════════════════════════════════════════════
   BUNDLE BUILDER — Cart Drawer Progress Bar JS
   Shows/hides a tier-based progress bar in the cart
   drawer based on eligible products in cart.

   NOTE — Discount application:
   Discounts are handled by a Shopify Discount Function
   (Shopify Functions API) that reads the _bundle_item
   and _bundle_id line-item properties set by
   bundle-builder-page.js. The Function groups items by
   _bundle_id, counts total quantity, and applies the
   correct tier percentage at checkout.
   No client-side discount code redirect needed here.
═══════════════════════════════════════════════════ */
(function initBundleBuilderCart() {
  'use strict';

  // Bail early if disabled in theme settings
  if (typeof window !== 'undefined' && window.__pf_bundle_builder_enabled === false) return;
  var bbBlock = document.getElementById('bbCartUpsell');
  if (!bbBlock) return;

  /* ─────────────────────────────────────────────────
     ELIGIBLE PRODUCTS
  ───────────────────────────────────────────────── */
  var eligibleIds = [];
  var rawIds = (bbBlock.getAttribute('data-eligible-product-ids') || '').trim();
  if (rawIds) {
    eligibleIds = rawIds.split(',').map(function(id) { return id.trim(); }).filter(function(id) { return id && id !== '0'; });
  }

  var eligibleHandles = [];
  var rawHandles = (bbBlock.getAttribute('data-eligible-product-handles') || '').trim();
  if (rawHandles) {
    eligibleHandles = rawHandles.split(',').map(function(h) { return h.trim(); }).filter(Boolean);
  }

  var hasConfig = eligibleIds.length > 0 || eligibleHandles.length > 0;

  function isEligible(item) {
    if (eligibleIds.length && eligibleIds.some(function(id) { return String(item.product_id) === id; })) return true;
    if (eligibleHandles.length && item.handle && eligibleHandles.some(function(h) { return item.handle === h; })) return true;
    if (!hasConfig) return true;
    return false;
  }

  /* A cart item only counts as part of the bundle if it was explicitly added
     through the bundle builder page — identified by the _bundle_item line
     property set by bundle-builder-page.js.
     Products that happen to be "eligible" but were added from other pages
     (PDP, recommendations, etc.) must NOT be counted or grouped. */
  function isBundleItem(item) {
    if (!item.properties) return false;
    return item.properties['_bundle_item'] === 'true' || item.properties['_bundle_item'] === true;
  }

  /* ─────────────────────────────────────────────────
     TIERS
  ───────────────────────────────────────────────── */
  var tiers = [];
  try {
    var rawTiers = JSON.parse(bbBlock.getAttribute('data-tiers') || '[]');
    tiers = rawTiers
      .filter(function(t) { return t.qty > 0; })
      .sort(function(a, b) { return a.qty - b.qty; });
  } catch(e) { tiers = []; }
  if (!tiers.length) {
    tiers = [
      { qty: 2, pct: 15, label: '2 products – 15% off' },
      { qty: 3, pct: 20, label: '3 products – 20% off' },
      { qty: 4, pct: 25, label: '4 products – 25% off' }
    ];
  }

  var maxQty = tiers[tiers.length - 1].qty;

  function getActiveTier(qty) {
    var active = null;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].qty) { active = tiers[i]; break; }
    }
    return active;
  }

  /* ─────────────────────────────────────────────────
     PROGRESS BAR
  ───────────────────────────────────────────────── */
  function updateProgressBar(eligibleQty) {
    var fillBar    = bbBlock.querySelector('[data-bb-fill]');
    var nextGrid   = bbBlock.querySelector('[data-bb-next-grid]');
    var nextText   = bbBlock.querySelector('[data-bb-next-text]');
    var unlockedEl = bbBlock.querySelector('[data-bb-unlocked-text]');
    var counterEl  = bbBlock.querySelector('[data-bb-counter]');
    var tierLabels = bbBlock.querySelectorAll('[data-bb-tier-label]');

    var fillPct = Math.min(Math.round((eligibleQty / maxQty) * 100), 100);
    var clipPct = 100 - fillPct;

    if (fillBar)  fillBar.style.width = fillPct + '%';
    if (nextGrid) nextGrid.style.clipPath = 'inset(0px ' + clipPct + '% 0px 0px)';
    if (counterEl) counterEl.textContent = '(' + eligibleQty + '/' + maxQty + ')';

    var unlockedTier = getActiveTier(eligibleQty);
    if (unlockedEl) {
      unlockedEl.textContent = unlockedTier ? unlockedTier.pct + '% off unlocked!' : '';
    }

    var nextTier = null;
    for (var j = 0; j < tiers.length; j++) {
      if (tiers[j].qty > eligibleQty) { nextTier = tiers[j]; break; }
    }
    if (nextText) {
      if (nextTier) {
        var need = nextTier.qty - eligibleQty;
        nextText.textContent = 'Add ' + need + ' more for ' + nextTier.pct + '% off';
      } else {
        nextText.textContent = 'Max discount unlocked! 🎉';
      }
    }

    tierLabels.forEach(function(lbl) {
      var tierQty = parseInt(lbl.getAttribute('data-tier-qty') || '0', 10);
      lbl.classList.toggle('is-active', unlockedTier !== null && tierQty <= eligibleQty);
    });
  }

  /* ─────────────────────────────────────────────────
     BUNDLE GROUP CARD
     The card lives in #bb-group-card-anchor — a sibling
     div inserted in cart-drawer.liquid right after
     [data-products]. Motion only ever replaces the
     contents of [data-products], so it NEVER touches
     the anchor and the card is never destroyed.

     groupBundleItems:
     - Reads bundle items from .cart__items (DOM)
     - If card content unchanged → just re-hides source rows
     - If changed → patches card text + carousel in-place
     - If no bundle items → removes the card
     - Source .cart__item rows are hidden with display:none
  ───────────────────────────────────────────────── */

  var savedCardKey = null;

  /* Keys (cart line item keys) of the current bundle items,
     populated on every fetchCartAndSync so removeBundle always
     has fresh data and never relies on the DOM. */
  var bundleLineKeys = [];

  /* ── Remove entire bundle from cart ── */
  var removeBundleInFlight = false;

  function removeBundle() {
    if (!bundleLineKeys.length) return;
    if (removeBundleInFlight) return; // already in progress — ignore extra clicks
    removeBundleInFlight = true;

    var keysToRemove = bundleLineKeys.slice(); // snapshot before clearing
    var updates = {};
    keysToRemove.forEach(function(k) { updates[k] = 0; });

    // Disable the X button to prevent double-clicks — do NOT touch the card.
    var btn = document.querySelector('.bb-group-card__remove-btn');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    // Cloak [data-products] RIGHT NOW so any re-render that happens during the
    // API round-trip never shows the bundle rows as individual items.
    // The card itself stays visible until the API confirms success.
    var productsEl = document.querySelector('[data-products]');
    if (productsEl) productsEl.classList.add('bb-cloaked');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('update failed');
      // No need to fetch /cart.js here — the MutationObserver triggered by
      // Motion's buildCart() will call fetchCartAndSync() which fetches it.
      return r.json();
    })
    .then(function() {
      removeBundleInFlight = false;
      bundleLineKeys = [];
      savedCardKey = null;

      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (productsEl) productsEl.classList.remove('bb-cloaked');
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        });
    })
    .catch(function() {
      removeBundleInFlight = false;
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      if (productsEl) productsEl.classList.remove('bb-cloaked');
      fetchCartAndSync();
    });
  }

  /* ── Remove a single bundle line item from cart ── */
  var removeLineItemInFlight = false;

  function removeLineItem(key) {
    if (!key) return;
    if (removeLineItemInFlight) return;
    removeLineItemInFlight = true;

    // Optimistically disable the clicked button
    var btn = document.querySelector('.bb-group-card__slide-remove[data-key="' + key + '"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    // Cloak immediately to prevent flash
    var productsEl = document.querySelector('[data-products]');
    if (productsEl) {
      productsEl.classList.add('bb-cloaked');
      setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 4000);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: { [key]: 0 } })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    })
    .then(function() {
      removeLineItemInFlight = false;
      bundleLineKeys = bundleLineKeys.filter(function(k) { return k !== key; });
      savedCardKey = null;
      var cartForm = document.querySelector('#CartDrawerForm') || document.body;
      cartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    })
    .catch(function() {
      removeLineItemInFlight = false;
      if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      if (productsEl) productsEl.classList.remove('bb-cloaked');
      fetchCartAndSync();
    });
  }

  function formatMoney(cents) {
    var val = cents / 100;
    return '$' + (val % 1 === 0 ? val.toFixed(0) : val.toFixed(2));
  }

  function buildProductRowsHTML(bundleItems, activeTier) {
    var rows = [];
    bundleItems.forEach(function(item) {
      var titleSafe = item.title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var titleUpper = item.title.toUpperCase();

      var imgHTML = item.imgSrc
        ? '<img src="' + item.imgSrc + '" alt="' + titleSafe + '" width="100" height="100" loading="lazy">'
        : '<div class="bb-product-row__img-placeholder"></div>';

      var priceHTML = '<span class="bb-product-row__price">' + formatMoney(item.finalPrice) + '</span>';
      if (item.originalPrice && item.originalPrice > item.finalPrice) {
        priceHTML += ' <span class="bb-product-row__compare">' + formatMoney(item.originalPrice) + '</span>';
      }

      var discountHTML = '';
      if (activeTier) {
        discountHTML = '<div class="bb-product-row__discount">' +
          '<svg class="bb-product-row__tag-icon" width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><path d="M2 2h5.586a1 1 0 0 1 .707.293l6 6a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-6-6A1 1 0 0 1 2 7.586V2zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg>' +
          activeTier.qty + '+ for ' + activeTier.pct + '% off' +
        '</div>';
      }

      var subscriptionHTML = '';
      if (item.sellingPlanName) {
        subscriptionHTML = '<div class="bb-product-row__subscription">' +
          '<svg class="bb-product-row__cal-icon" width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><path d="M11 1a.5.5 0 0 1 .5.5V2h1A1.5 1.5 0 0 1 14 3.5V13a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13V3.5A1.5 1.5 0 0 1 3.5 2h1V1.5a.5.5 0 0 1 1 0V2h5V1.5a.5.5 0 0 1 .5-.5zM3.5 3a.5.5 0 0 0-.5.5V4h10v-.5a.5.5 0 0 0-.5-.5h-9zM3 5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V5H3z"/></svg>' +
          item.sellingPlanName +
        '</div>';
      }

      var variantHTML = item.variantTitle
        ? '<div class="bb-product-row__variant">' + item.variantTitle + '</div>'
        : '';

      rows.push(
        '<div class="bb-product-row" data-key="' + item.key + '">' +
          '<div class="bb-product-row__img-wrap">' + imgHTML + '</div>' +
          '<div class="bb-product-row__details">' +
            '<div class="bb-product-row__title">' + titleUpper + '</div>' +
            variantHTML +
            '<div class="bb-product-row__price-row">' + priceHTML + '</div>' +
            discountHTML +
            subscriptionHTML +
          '</div>' +
          '<div class="bb-product-row__actions">' +
            '<div class="bb-qty-wrap" tabindex="0">' +
              '<div class="bb-qty-inner">' +
                '<button type="button" class="bb-qty-btn bb-product-row__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">' +
                  '<svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12" aria-hidden="true"><path d="M3 8C3 7.72386 3.22386 7.5 3.5 7.5H12.5C12.7761 7.5 13 7.72386 13 8C13 8.27614 12.7761 8.5 12.5 8.5H3.5C3.22386 8.5 3 8.27614 3 8Z"/></svg>' +
                '</button>' +
                '<span class="bb-qty-num bb-product-row__qty">' + item.qty + '</span>' +
                '<button type="button" class="bb-qty-btn bb-product-row__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">' +
                  '<svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12" aria-hidden="true"><path d="M8 3C8.27614 3 8.5 3.22386 8.5 3.5V7.5H12.5C12.7761 7.5 13 7.72386 13 8C13 8.27614 12.7761 8.5 12.5 8.5H8.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V8.5H3.5C3.22386 8.5 3 8.27614 3 8C3 7.72386 3.22386 7.5 3.5 7.5H7.5V3.5C7.5 3.22386 7.72386 3 8 3Z"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="bb-product-row__remove" data-key="' + item.key + '" aria-label="Remove ' + titleSafe + '">' +
              '<svg viewBox="0 0 16 16" fill="currentColor" width="14" height="14" aria-hidden="true"><path d="M9 1C10.3807 1 11.5 2.11929 11.5 3.5V4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H13V12.5C13 13.8807 11.8807 15 10.5 15H5.5C4.11929 15 3 13.8807 3 12.5V5H2.5C2.22386 5 2 4.77614 2 4.5C2 4.22386 2.22386 4 2.5 4H4.5V3.5C4.5 2.11929 5.61929 1 7 1H9ZM10.5 4V3.5C10.5 2.67157 9.82843 2 9 2H7C6.17157 2 5.5 2.67157 5.5 3.5V4H10.5ZM4 5V12.5C4 13.3284 4.67157 14 5.5 14H10.5C11.3284 14 12 13.3284 12 12.5V5H4ZM6.5 7C6.77614 7 7 7.22386 7 7.5V11.5C7 11.7761 6.77614 12 6.5 12C6.22386 12 6 11.7761 6 11.5V7.5C6 7.22386 6.22386 7 6.5 7ZM9.5 7C9.77614 7 10 7.22386 10 7.5V11.5C10 11.7761 9.77614 12 9.5 12C9.22386 12 9 11.7761 9 11.5V7.5C9 7.22386 9.22386 7 9.5 7Z"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>'
      );
    });
    return rows.join('<div class="bb-product-row__separator"></div>');
  }

  /* ── Change qty of a single bundle line item ── */
  var changeQtyInFlight = false;

  function changeLineItemQty(key, newQty) {
    if (changeQtyInFlight) return;
    if (newQty < 0) return;
    changeQtyInFlight = true;

    var productsEl = document.querySelector('[data-products]');
    if (productsEl) {
      productsEl.classList.add('bb-cloaked');
      setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 4000);
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: { [key]: newQty } })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    })
    .then(function() {
      changeQtyInFlight = false;
      if (newQty === 0) {
        bundleLineKeys = bundleLineKeys.filter(function(k) { return k !== key; });
      }
      savedCardKey = null;
      var cartForm = document.querySelector('#CartDrawerForm') || document.body;
      cartForm.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    })
    .catch(function() {
      changeQtyInFlight = false;
      if (productsEl) productsEl.classList.remove('bb-cloaked');
      fetchCartAndSync();
    });
  }

  function bindRowButtons(container, bundleItems) {
    container.querySelectorAll('.bb-product-row__remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        removeLineItem(btn.getAttribute('data-key'));
      });
    });
    container.querySelectorAll('.bb-product-row__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var item = bundleItems.find(function(it) { return it.key === key; });
        var currentQty = item ? item.qty : 1;
        var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;
        if (newQty < 0) return;
        changeLineItemQty(key, newQty);
      });
    });
  }

  /* ── Carousel HTML builder (HPN-style: image grid + slide X) ── */
  function buildCarouselHTML(bundleItems) {
    return bundleItems.map(function(item) {
      var titleSafe = item.title.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var imgHTML = item.imgSrc
        ? '<img src="' + item.imgSrc + '" alt="' + titleSafe + '" width="72" height="72" loading="lazy">'
        : '<div style="width:72px;height:72px;background:#ddd;border-radius:8px;"></div>';
      return (
        '<div class="bb-group-card__slide">' +
          '<div class="bb-group-card__img-wrap">' +
            imgHTML +
            '<button type="button" class="bb-group-card__slide-remove" data-key="' + item.key + '" aria-label="Remove ' + titleSafe + '">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="1" y1="1" x2="9" y2="9"></line><line x1="9" y1="1" x2="1" y2="9"></line></svg>' +
            '</button>' +
          '</div>' +
          '<span class="bb-group-card__name">' + titleSafe + '</span>' +
        '</div>'
      );
    }).join('');
  }

  /* ── Bind per-slide remove buttons + drag scroll ── */
  function bindCarouselButtons(carousel) {
    carousel.querySelectorAll('.bb-group-card__slide-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        removeLineItem(btn.getAttribute('data-key'));
      });
    });
    initDragScroll(carousel);
  }

  /* ── Cart footer panel toggles (discount / note) ── */
  function initCartPanelToggles() {
    function setupToggle(btnId, panelId) {
      var btn = document.getElementById(btnId);
      var panel = document.getElementById(panelId);
      if (!btn || !panel) return;
      btn.addEventListener('click', function() {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        btn.setAttribute('aria-expanded', String(!isOpen));
        btn.classList.toggle('is-active', !isOpen);
        if (!isOpen && panelId === 'bb-discount-panel') {
          var input = document.getElementById('bb-discount-code');
          if (input) setTimeout(function() { input.focus(); }, 50);
        }
      });
    }
    setupToggle('bb-discount-toggle', 'bb-discount-panel');
    setupToggle('bb-note-toggle', 'bb-notes-panel');

    /* Discount apply (basic — submits as cart attribute for app handling) */
    var applyBtn = document.getElementById('bb-discount-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var code = (document.getElementById('bb-discount-code') || {}).value || '';
        if (!code.trim()) return;
        window.location.href = '/discount/' + encodeURIComponent(code.trim()) + '?redirect=/cart';
      });
    }
  }


  function groupBundleItems(bundleCartItems) {
    var anchor = document.getElementById('bb-group-card-anchor');
    var productsContainer = document.querySelector('[data-products]');
    if (!anchor || !productsContainer) return;

    var itemsContainer = productsContainer.querySelector('.cart__items') || productsContainer;

    // Helper: remove the visibility cloak once we've finished processing
    function uncloak() {
      productsContainer.classList.remove('bb-cloaked');
    }

    isGroupingItems = true;

    // ── PHASE 1: UNHIDE previously hidden rows (theme may have re-rendered them) ──
    itemsContainer.querySelectorAll('.cart__items__row[data-bb-hidden]').forEach(function(el) {
      el.removeAttribute('data-bb-hidden');
      el.style.display = '';
    });

    // ── PHASE 2: MATCH API bundle items to DOM rows ────────────────────────────────
    // bundleCartItems comes from /cart.js — only items with _bundle_item property.
    // We match each to its DOM row via data-key (Motion renders this attribute).
    var bundleItems = [];
    if (bundleCartItems && bundleCartItems.length) {
      bundleCartItems.forEach(function(apiItem) {
        // Find the corresponding DOM row by its key attribute
        var node = itemsContainer.querySelector('.cart__items__row[data-key="' + apiItem.key + '"]');

        var imgSrc = apiItem.featured_image && apiItem.featured_image.url
          ? apiItem.featured_image.url : '';
        if (!imgSrc && node) {
          var imgEl = node.querySelector('img');
          imgSrc = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '') : '';
        }
        if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        if (imgSrc) {
          imgSrc = imgSrc.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+(\?|$))/i, '$2');
          imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2');
        }

        var finalPrice    = apiItem.final_line_price != null ? Math.round(apiItem.final_line_price / (apiItem.quantity || 1)) : (apiItem.final_price || apiItem.price || 0);
        var originalPrice = apiItem.original_price || apiItem.price || 0;
        var variantTitle  = (apiItem.variant_title && apiItem.variant_title !== 'Default Title') ? apiItem.variant_title : '';
        var sellingPlanName = '';
        if (apiItem.selling_plan_allocation && apiItem.selling_plan_allocation.selling_plan) {
          sellingPlanName = apiItem.selling_plan_allocation.selling_plan.name || '';
        }

        bundleItems.push({
          node:            node,
          key:             apiItem.key,
          title:           apiItem.product_title || apiItem.title || '',
          imgSrc:          imgSrc,
          qty:             apiItem.quantity,
          finalPrice:      finalPrice,
          originalPrice:   originalPrice,
          variantTitle:    variantTitle,
          sellingPlanName: sellingPlanName
        });
      });
    }

    // ── PHASE 2.5: RETRY if DOM nodes haven't rendered yet ──────────────────────
    var missingNodes = bundleItems.length > 0 && bundleItems.some(function(it) { return !it.node; });
    if (missingNodes) {
      isGroupingItems = false;
      return;
    }

    // ── PHASE 3: DECIDE ───────────────────────────────
    var existingCard = anchor.querySelector('.bb-group-card');

    if (!bundleItems.length) {
      if (existingCard) existingCard.remove();
      savedCardKey = null;
      uncloak();
      requestAnimationFrame(function() { requestAnimationFrame(function() { isGroupingItems = false; }); });
      return;
    }

    var totalQty    = bundleItems.reduce(function(sum, it) { return sum + it.qty; }, 0);
    var activeTier  = getActiveTier(totalQty);
    var tierPct     = activeTier ? activeTier.pct : 0;
    var fingerprint = bundleItems.map(function(it) { return it.key + ':' + it.qty; }).join('|') + '@' + tierPct;

    // ── PHASE 4: COMMIT ───────────────────────────────
    if (!existingCard) {
      existingCard = document.createElement('div');
      existingCard.className = 'bb-group-card';
      existingCard.innerHTML =
        '<div class="bb-group-card__header">' +
          '<span class="bb-group-card__title"></span>' +
          '<span class="bb-group-card__tier-label" data-bb-tier-label style="display:none"></span>' +
          '<span class="bb-group-card__sub-badge" data-bb-sub-badge style="display:none">' +
            '<svg class="bb-group-card__sub-icon" width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M11.5 1C11.776 1 12 1.224 12 1.5V2.5H13C14.105 2.5 15 3.395 15 4.5V13C15 14.105 14.105 15 13 15H3C1.895 15 1 14.105 1 13V4.5C1 3.395 1.895 2.5 3 2.5H4V1.5C4 1.224 4.224 1 4.5 1C4.776 1 5 1.224 5 1.5V2.5H11V1.5C11 1.224 11.224 1 11.5 1ZM2 6.5V13C2 13.552 2.448 14 3 14H13C13.552 14 14 13.552 14 13V6.5H2ZM3 3.5C2.448 3.5 2 3.948 2 4.5V5.5H14V4.5C14 3.948 13.552 3.5 13 3.5H3Z" fill="currentColor"></path></svg>' +
            'Subscription' +
          '</span>' +
          '<button type="button" class="bb-group-card__remove-btn" aria-label="Remove bundle" title="Remove all bundle items">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bb-group-card__carousel" data-bb-carousel></div>';
      existingCard.querySelector('.bb-group-card__remove-btn').addEventListener('click', function(e) {
        e.stopPropagation();
        removeBundle();
      });
      anchor.appendChild(existingCard);
    }

    if (savedCardKey !== fingerprint) {
      var titleEl2 = existingCard.querySelector('.bb-group-card__title');
      if (titleEl2) titleEl2.textContent = 'Bundle (' + totalQty + ' item' + (totalQty !== 1 ? 's' : '') + ')';

      var tierLabelEl = existingCard.querySelector('[data-bb-tier-label]');
      if (tierLabelEl) {
        if (activeTier) {
          tierLabelEl.textContent = tierPct + '% off unlocked';
          tierLabelEl.style.display = '';
        } else {
          tierLabelEl.style.display = 'none';
        }
      }

      var hasSubscription = bundleItems.some(function(it) { return !!it.sellingPlanName; });
      var subBadgeEl = existingCard.querySelector('[data-bb-sub-badge]');
      if (subBadgeEl) subBadgeEl.style.display = hasSubscription ? '' : 'none';

      var carousel = existingCard.querySelector('[data-bb-carousel]');
      if (carousel) {
        carousel.innerHTML = buildCarouselHTML(bundleItems);
        bindCarouselButtons(carousel);
      }
      savedCardKey = fingerprint;
    }

    // ── PHASE 5: HIDE matched DOM rows ────────────────
    bundleItems.forEach(function(item) {
      if (!item.node) return;
      item.node.setAttribute('data-bb-hidden', '1');
      item.node.style.display = 'none';
    });

    // Rows are hidden — safe to reveal [data-products]
    uncloak();
    requestAnimationFrame(function() { requestAnimationFrame(function() { isGroupingItems = false; }); });
  }

  function initDragScroll(el) {
    if (!el) return;
    var isDown = false;
    var startX, scrollLeftStart;
    var canDrag = false;

    function updateCursor() {
      canDrag = el.scrollWidth > el.clientWidth;
      el.style.cursor = canDrag ? 'grab' : 'default';
    }
    updateCursor();
    if (window.ResizeObserver) {
      new ResizeObserver(updateCursor).observe(el);
    }

    el.addEventListener('mousedown', function(e) {
      if (!canDrag) return;
      if (e.button !== 0) return;
      isDown = true;
      startX = e.pageX;
      scrollLeftStart = el.scrollLeft;
      el.classList.add('is-grabbing');
      document.body.style.userSelect = 'none';
      document.body.style.webkitUserSelect = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      el.scrollLeft = scrollLeftStart - dx;
    });

    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('is-grabbing');
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
    });
  }

  /* ─────────────────────────────────────────────────
     SYNC
  ───────────────────────────────────────────────── */
  function updateBadgeLabels(eligibleQty) {
    var activeTier = getActiveTier(eligibleQty);
    document.querySelectorAll('[data-bb-item-badge]').forEach(function(badge) {
      var label = badge.querySelector('.bb-cart-item-badge__label');
      if (!label) return;
      label.textContent = activeTier ? 'Bundle – ' + activeTier.pct + '% off' : 'Bundle';
    });
  }

  function syncVisibility(cartItems) {
    if (!cartItems || !cartItems.length) {
      bbBlock.style.display = 'none';
      bundleLineKeys = [];
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }

    // Only items explicitly added through the bundle builder count
    var bundleItems = cartItems.filter(isBundleItem);
    var bundleQty   = bundleItems.reduce(function(sum, it) { return sum + it.quantity; }, 0);

    // Save keys for removeBundle — always fresh from the API response
    bundleLineKeys = bundleItems.map(function(it) { return it.key; });

    if (bundleQty < 1) {
      bbBlock.style.display = 'none';
      updateBadgeLabels(0);
      isGroupingItems = false;
      groupBundleItems([]);
      return;
    }
    updateProgressBar(bundleQty);
    updateBadgeLabels(bundleQty);
    bbBlock.style.display = '';
    groupBundleItems(bundleItems);
  }

  /* ─────────────────────────────────────────────────
     SYNC SCHEDULING
     fetchCartAndSync  — debounced /cart.js fetch
     (single entry point for all sync operations)
  ───────────────────────────────────────────────── */
  var isGroupingItems = false;
  var syncDebounceTimer = null;

  function fetchCartAndSync() {
    clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(function() {
      isGroupingItems = false; // always unlock before fetch so nothing stays stuck
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { syncVisibility(cart.items); })
        .catch(function() {
          isGroupingItems = false;
          // Remove cloak on error so the drawer doesn't stay invisible
          var el = document.querySelector('[data-products]');
          if (el) el.classList.remove('bb-cloaked');
        });
    }, 60);
  }

  /* ─────────────────────────────────────────────────
     EVENT LISTENERS
     ─────────────────────────────────────────────────
     We intentionally do NOT listen to theme:cart:change
     or cart:updated.  Those events fire BEFORE Motion
     has re-rendered the drawer, so listening to them
     caused cascading /cart.js fetches:
       1. Our listener → fetchCartAndSync → /cart.js
       2. ajaxProduct:added → Motion buildCart → DOM
          mutation → MutationObserver → fetchCartAndSync
          → /cart.js (again)
       3. Motion's buildCart dispatches cart:updated
          internally → our listener (again) → /cart.js
       4. theme:cart:change retry cascade (200/500/1000ms)
          → 3 more /cart.js fetches

     Instead we rely on exactly TWO sync entry points:
       A. MutationObserver on [data-products] — fires
          once after Motion finishes buildCart()
       B. Drawer-open observer — fires when drawer opens
     Both funnel into fetchCartAndSync (60ms debounce)
     so a single action = exactly 1 /cart.js fetch.
  ───────────────────────────────────────────────── */

  // Drawer open — re-sync each time the drawer becomes visible
  // This theme uses data-drawer="drawer-cart" with id="drawer-cart" and class "drawer--visible"
  var drawer = document.getElementById('CartDrawer') ||
               document.getElementById('drawer-cart') ||
               document.querySelector('[data-drawer="drawer-cart"]');
  if (drawer) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (drawer.classList.contains('js-drawer-open') ||
              drawer.classList.contains('is-open') ||
              drawer.classList.contains('drawer--visible')) {
            fetchCartAndSync();
            initCartPanelToggles();
          }
        }
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch [data-products] — Motion replaces its innerHTML on every cart update.
  // When that happens (childList change on the container itself) we re-sync.
  var productsEl = document.querySelector('[data-products]');
  if (productsEl) {
    new MutationObserver(function(mutations) {
      if (isGroupingItems) return;
      // Ignore mutations we caused ourselves (attribute flips on hidden rows)
      var isOwnMutation = mutations.every(function(m) {
        if (m.type === 'attributes') {
          return m.target.hasAttribute('data-bb-hidden') || m.attributeName === 'data-bb-hidden';
        }
        return false;
      });
      if (isOwnMutation) return;
      // If there are active bundle items, cloak immediately before Motion finishes
      // painting so bundle rows never flash as individual items during re-renders
      // triggered by recs adds or any other cart event.
      if (bundleLineKeys.length > 0) {
        productsEl.classList.add('bb-cloaked');
        setTimeout(function() { productsEl.classList.remove('bb-cloaked'); }, 3000);
      }
      fetchCartAndSync();
    }).observe(productsEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bb-hidden'] });
  }

  fetchCartAndSync();
})();
